export default __webpack_public_path__ + "static/media/clear.3548c7e2.svg";